/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { BnNgIdleService } from 'bn-ng-idle';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { BlipChatService } from './shared/services/blip.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'ngx-app',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

  height = 4;
  color = "#a4c052";
  runInterval = 300;


  alertOptions: any = {
    timeOut: 5000,
    preventLastDuplicates: true,
    maxStack: 3,
    showProgressBar: true
  }

  constructor(private analytics: AnalyticsService,
    private bnIdle: BnNgIdleService,
    private router: Router,
    private notifications: NotificationsService,
    private blipChatService: BlipChatService) {
  }

  ngOnInit(): void {
    this.analytics.trackPageViews();
    var count = 0;

    let time = localStorage.getItem('bway-Session-Time');

    if (time != null) {

      this.bnIdle.startWatching(time).subscribe((isTimedOut: boolean) => {

        if (isTimedOut) {

          this.router.navigate(['/login']);
          if (count == 0) {
            this.notifications.error('Sessão expirada!!!')
            count = 1
          }

        }
      });
    }

    this.blipChatService.init(
      environment.blip_key,
      environment.blip_url
    );

    document.getElementById('blip-chat-container').setAttribute('style', `
        position: absolute;
        bottom: 0px;
        right: 0px;
      `)
    document.getElementById('blip-chat-open-iframe').setAttribute('style', `
        position: absolute;
        bottom: 8px;
        right: 8px;
      `)
    
  }
}
